import { Button, Card, Col, Divider, Flex, Input, message, Pagination, Row, Select, Spin, Typography, Grid, Tag, Segmented } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import { useDebounce } from "use-debounce";
import React, { useEffect, useState } from "react";

import TreatmentPlanDetailsOrPaymentRequest from "./component/TreatmentPlanDetailsOrPaymentRequest";
import DashboardLayout from "../../layout/dashboardLayout/DashboardLayout";
import PaymentReportModal from "./component/PaymentReportModal";
import TreatmentCard from "./component/TreatmentCard";
import AgentRunsLauncher from "../ScrapeJobs/AgentRunsLauncher";
import TreatmentFilters from "./TreatmentsFilter";
import ManageTagsModal from "./ManageTagsModal";
import ModalComponent from "./component/Modal";

import completed from "../../assets/icons/completed.svg";
import search from "../../assets/icons/input-affix.jpg";
import archive from "../../assets/icons/archive.svg";
import filter1 from "../../assets/icons/filter.png";
import send from "../../assets/icons/send-2.svg";
import "./style.css";

import { Paymentcontroller } from "../../Paymentcontroller";
import { controller } from "./controller";
import { paletteForTag } from "./lib/tagColors";
import { MISSING_INFO_TAG_NAME, REQUEST_TYPES } from "../InsuranceRequests/requestTypes";
import { patientSearchParams } from "./lib/patientSearch";

const { useBreakpoint } = Grid;

export default function TreatmentPlansPage() {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [data, setData] = useState([]);
  const [list, setList] = useState([]);
  const [filter, setFilter] = useState([]);
  const [currentStep, setCurrentStep] = useState(1); // Added state for tracking the current step
  const [selectedPatient, setSelectedPatient] = useState(null); // State for selected patient
  // const [isGettingProcedures, setIsGettingProcedures] = useState(false);
  // const [allProcedures, setAllProcedures] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [debounceSearchQuery] = useDebounce(searchQuery, 1000);
  const [newPatientID, setNewPatientID] = useState("");

  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(0);
  const [itemlist, setItemList] = useState([]);
  const [members, setMembers] = useState([]);
  const [isLoadingMembers, setIsloadingMembers] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [isGettingRequiringActionData, setIsGettingRequiringActionData] = useState(false);
  const [isGettingCaredForPatients, setIsGettingCaredForPatients] = useState(false);
  const [isGettingPastAppointment, setIsGettingPastAppointment] = useState(false);
  const [isGettingHandledAR, setIsGettingHandledAR] = useState(false);
  const [isGettingTodayPatients, setIsGettingTodayPatients] = useState(false);
  const [selectedSegment, setSelectedSegment] = useState(
    window.location.href.includes("treatment-plans-account-receivable") ||
      localStorage.getItem("patient-engagment-sub") === "treatment-plans-account-receivable"
      ? "ar-cases"
      : "all-patients",
  );
  const [requiringActionsData, setRequiringActionsData] = useState([]);
  const [caredForPatients, setCaredForPatients] = useState([]);
  const [pastAppointmentPatients, setPastAppointmentPatients] = useState([]);
  const [arHandledPatients, setARHandledPatients] = useState([]);
  const [todayPatients, setTodayPatients] = useState([]);
  const [upcomingRange, setUpcomingRange] = useState("today");
  // const [selectedRequiringActionFilter, setSelectedRequiringActionFilter] = useState("treatment_only");
  const [showManageTagsModal, setShowManageTagsModal] = useState(false);
  const [isGettingTags, setIsGettingTags] = useState(false);
  const [showPaymentReportModal, setShowPaymentReportModal] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [allTags, setAllTags] = useState([]);
  const [noneDefaultTags, setNoneDefaultTags] = useState([]);
  const [defaultTags, setDefaultTags] = useState([]);
  const [freshCounts, setFreshCounts] = useState({ breakdowns: null, estimates: null, needsAttention: null });
  const [sortPatientsBy, setSortPatientsBy] = useState("asc");
  const [arHandledFilter, setARHandledFilter] = useState([]);
  const [treatmentFilters, setTreatmentFilters] = useState({
    name: "",
    phone: "",
    email: "",
    not_completed_within_months: "",
    not_completed_procedure_ids: [],
    completed_within_months: "",
    completed_procedure_ids: [],
    planned_within_months: "",
    planned_procedure_ids: [],
  });

  const [isGettingHelcimApprovedCard, setIsGettingHelcimApprovedCard] = useState(false);
  const [payResult, setPayResult] = useState(null);
  const [payResult1, setPayResult1] = useState(null);
  const [response, setResponse] = useState("");
  const [response2, setResponse2] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [currentPaymentStep, setCurrentPaymentStep] = useState(sessionStorage.getItem("currentStep") || 1);

  const treatmentPlansSegmentOptions =
    window.location.href.includes("treatment-plans-account-receivable") ||
    localStorage.getItem("patient-engagment-sub") === "treatment-plans-account-receivable"
      ? [
          { label: "Pending ARs", value: "ar-cases", className: "treatment-plan-segment-item" },
          { label: "Handled ARs", value: "ar-handled", className: "treatment-plan-segment-item" },
        ]
      : [
          { label: <span data-onboarding-id="tab-all-patients">All Patients</span>, value: "all-patients", className: "treatment-plan-segment-item" },
          { label: <span data-onboarding-id="tab-upcoming">Upcoming Patients</span>, value: "upcoming-patients", className: "treatment-plan-segment-item" },
          {
            label: (
              <span data-onboarding-id="tab-fresh-breakdowns">
                {freshCounts.breakdowns != null ? `New Breakdowns (${freshCounts.breakdowns})` : "New Breakdowns"}
              </span>
            ),
            value: "fresh-breakdowns",
            className: "treatment-plan-segment-item",
          },
          {
            label: (
              <span data-onboarding-id="tab-new-estimates">
                {freshCounts.estimates != null ? `New Estimates (${freshCounts.estimates})` : "New Estimates"}
              </span>
            ),
            value: "new-estimates",
            className: "treatment-plan-segment-item",
          },
          {
            label: (
              <span data-onboarding-id="tab-need-attention">
                {freshCounts.needsAttention != null ? `Details Needed by Smilepass (${freshCounts.needsAttention})` : "Details Needed by Smilepass"}
              </span>
            ),
            value: "need-attention",
            className: "treatment-plan-segment-item",
          },
          // Hidden for now — keep the code paths around in case we need them back.
          // { label: "Today's Patients", value: "today-patients", className: "treatment-plan-segment-item" },
          // { label: "Require Prep", value: "requiring-action", className: "treatment-plan-segment-item" },
          // { label: "Prepared Plans", value: "cared-for", className: "treatment-plan-segment-item" },
          // { label: "Past Appointments", value: "past-appointment", className: "treatment-plan-segment-item" },
        ];

  const upcomingRangeOptions = [
    { label: "Today", value: "today", startDays: 0, endDays: 0 },
    { label: "Up to 2 Weeks", value: "0-2w", startDays: 0, endDays: 14 },
    { label: "2 to 4 Weeks", value: "2-4w", startDays: 15, endDays: 28 },
    { label: "4 to 6 Weeks", value: "4-6w", startDays: 29, endDays: 42 },
    { label: "6 to 8 Weeks", value: "6-8w", startDays: 43, endDays: 56 },
  ];

  const arFilterSegments = [
    // { label: "0-29", value: "amount_between_0_30", className: "requiring-action-segment-item" },
    { label: "30-59", value: "amount_between_31_60", className: "requiring-action-segment-item" },
    { label: "60-89", value: "amount_between_61_90", className: "requiring-action-segment-item" },
    { label: "+90", value: "amount_greater_than_90", className: "requiring-action-segment-item" },
  ];

  // SECTION: useEffect

  useEffect(function () {
    const getUrlParameter = (name) => {
      const urlParams = new URLSearchParams(window.location.search);
      if (name) {
        return urlParams.get(name) ? decodeURIComponent(urlParams.get(name).replace(/\+/g, " ")) : "";
      }
      return window.location.href; // Return the complete URL if no parameter name is provided
    };

    // Get the value of responseMessage and cardToken from URL parameters
    const responseMessage = getUrlParameter("responseMessage");
    const responseMessage2 = getUrlParameter();
    const cardToken = getUrlParameter("cardToken");

    // Check if responseMessage is "APPROVED" and log cardToken
    if (
      responseMessage === "APPROVED" ||
      responseMessage === "APPROVAL" ||
      (window.location.href.includes("/?") && !window.location.href.includes("/?id="))
    ) {
      try {
        handleReadDataIP();

        setCurrentPaymentStep(2);
        setShowPaymentReportModal(true);

        const pay = localStorage.getItem("treatment.type");

        // Check the payment type and call the appropriate function
        if (pay === "wizard") {
          handleApprovedCardByHelcim2(cardToken, responseMessage2);
        } else {
          handleApprovedCardByHelcim(cardToken, responseMessage2);
        }

        window.history.replaceState({}, "", window.location.pathname);
      } catch (error) {
        console.error("Error handling payment:", error);
      }
    } else {
      console.log("Payment not approved or missing necessary URL parameters.");
      // Optionally, update the state to indicate the loading or checking has concluded without action
    }
  }, []);

  useEffect(function () {
    getAllTags();
  }, []);

  useEffect(
    function () {
      if (defaultTags && defaultTags.length) loadFreshCounts();
    },
    [defaultTags],
  );

  useEffect(
    function () {
      setCurrent(1);
      getPatientsBySegment();
    },
    [treatmentFilters],
  );

  // useEffect(
  //   function () {
  //     getPatientsBySegment();
  //   },
  //   [current]
  // );

  useEffect(
    function () {
      setCurrent(1);
      getPatientsBySegment(1);
    },
    [selectedTags, sortPatientsBy, selectedSegment, arHandledFilter, upcomingRange],
  );

  useEffect(function () {
    // This get removed each time you enter the patient board from locationStorage
    const patientFromPatientBoard = localStorage.getItem("patient-from-patient-board-for-treatment");
    const patientFromPaymentRequest = localStorage.getItem("treatment.pat_id");

    if (patientFromPatientBoard || patientFromPaymentRequest) {
      const parsedPatientFromPatientBoard = JSON.parse(patientFromPatientBoard || patientFromPaymentRequest);
      setCurrentPaymentStep(2);
      setSelectedPatient(parsedPatientFromPatientBoard);
      setNewPatientID(parsedPatientFromPatientBoard.id);
    }
  }, []);

  useEffect(() => {
    getData();
  }, []);

  // INFO: Let's keep this, it might be needed later
  // // Getting all procedures
  // useEffect(function () {
  //   async function getAllProcedures() {
  //     try {
  //       setIsGettingProcedures(true);
  //       const res = await controller.getProcedure(0, "");
  //       setAllProcedures(res.json);
  //     } catch (err) {
  //       message.error("Something went wrong while fetching procedures");
  //       console.error(err);
  //     } finally {
  //       setIsGettingProcedures(false);
  //     }
  //   }
  //   getAllProcedures();
  // }, []);

  // An input for filtering patients based on name, email and phone number.
  // The term-shape routing is shared with the FTC Tasks search so the two
  // pages match on exactly the same rules — see lib/patientSearch.
  useEffect(() => {
    setTreatmentFilters((prevFilters) => ({
      ...prevFilters,
      // patientSearchParams always returns all three keys, so the ones that no
      // longer apply are cleared and can't go stale.
      ...patientSearchParams(debounceSearchQuery),
    }));
  }, [debounceSearchQuery]);

  // SECTION: Functions

  const handleApprovedCardByHelcim = async (cardToken, responseMessage2) => {
    var id = localStorage.getItem("treatment.paymentId");
    if (!id) {
      console.error("No selected ID provided");
      message.error("Payment failed: No selected ID provided.");
      return;
    }

    setIsGettingHelcimApprovedCard(true);
    try {
      const ipResponse = await fetch("https://api.ipify.org?format=json");
      const ipData = await ipResponse.json();
      const userIp = ipData.ip;

      const response = await Paymentcontroller.helcimPay(id, cardToken, userIp, responseMessage2);

      if (response.status < 250) {
        message.success("Payment successful");
        window.history.pushState({}, "", `/#/treatment-plans`); // Update the URL without reloading the page
        setCurrentPaymentStep(2);
        setPayResult(true);
        setTimeout(() => {
          window.location.href =
            localStorage.getItem("patient-engagment-sub") === "treatment-plans-account-receivable"
              ? "/#/treatment-plans-account-receivable"
              : "/#/treatment-plans";
        }, 3000);
      } else {
        message.error("Payment failed: " + response.error);
        setPayResult(false);
        setCurrentPaymentStep(2);
        setResponse(response.error);
        setTimeout(() => {
          window.location.href =
            localStorage.getItem("patient-engagment-sub") === "treatment-plans-account-receivable"
              ? "/#/treatment-plans-account-receivable"
              : "/#/treatment-plans";
        }, 3000);
      }
    } catch (error) {
      console.error("Error during payment processing:", error);
      message.error("Payment processing error: " + error.message);
    } finally {
      setIsGettingHelcimApprovedCard(false);
    }
  };

  const handleApprovedCardByHelcim2 = async (cardToken, responseMessage2) => {
    var id = localStorage.getItem("treatment.paymentId");
    setIsGettingHelcimApprovedCard(true);

    try {
      const ipResponse = await fetch("https://api.ipify.org?format=json");
      const ipData = await ipResponse.json();
      const userIp0 = ipData.ip;

      const response = await Paymentcontroller.helcimPayMulti(id, cardToken, userIp0, responseMessage2);

      if (response.status < 250) {
        // onNextStep();  // Call the parent component's method to go to the next step
        sessionStorage.setItem("currentStep", 2);
        setCurrentPaymentStep(2);
        setPayResult1(true);
        setTimeout(() => {
          window.location.href =
            localStorage.getItem("patient-engagment-sub") === "treatment-plans-account-receivable"
              ? "/#/treatment-plans-account-receivable"
              : "/#/treatment-plans";
        }, 3000);
      } else {
        Object.keys(response).forEach((resp) => {
          if (resp !== "status") message.error(response[resp]);
        });

        setPayResult1(false);
        setCurrentPaymentStep(2);
        setResponse2(response.error);
        setTimeout(() => {
          window.location.href =
            localStorage.getItem("patient-engagment-sub") === "treatment-plans-account-receivable"
              ? "/#/treatment-plans-account-receivable"
              : "/#/treatment-plans";
        }, 3000);
      }
    } catch (error) {
      console.error("Error fetching IP address:", error);
    } finally {
      setIsGettingHelcimApprovedCard(false);
    }
  };

  const handleReadDataIP = async () => {
    try {
      const ipResponse = await fetch("https://api.ipify.org?format=json");
      const ipData = await ipResponse.json();
      const userIp0 = ipData.ip;
      return userIp0.ip;
    } catch (error) {
      console.error("Error fetching IP address:", error);
    }
    return null;
  };

  const getData = async () => {
    try {
      const response = await controller.getData();
      const data = await response.json;
      setItemList(data);
    } catch (error) {
      console.error("Error fetching patients:", error);
    }
  };

  // `silent`: skip toggling `isLoadingMembers` so the list block doesn't
  // get swapped out for the <Spin /> on background refreshes (e.g. the
  // refetch fired after a tag commit). Without this, every TreatmentCard
  // unmounts mid-fetch and loses its local state — including the
  // optimistic chip the user just added.
  const getAllPatients = async (page, silent = false) => {
    try {
      if (!silent) setIsloadingMembers(true);
      const response = await controller.getMemberList2(page || current, treatmentFilters, selectedTags);
      const data = await response.json;

      setMembers(data);
      setPageSize(data.count);
    } catch (error) {
      console.log("Error fetching patients:", error);
      message.error("Something went wrong while getting patients");
    } finally {
      if (!silent) setIsloadingMembers(false);
    }
  };

  // "Fresh" segments — patients whose breakdown/estimate work just completed,
  // surfaced by the outcome tags the scraper/worker/manual flows now apply.
  const FRESH_BREAKDOWN_TAG = "Breakdown - Verified";
  const NEW_ESTIMATE_TAG = "New Estimate Available";
  const NEEDS_ATTENTION_TAG = MISSING_INFO_TAG_NAME;

  const freshTagId = (name) => {
    const t = (defaultTags || []).find((x) => x.name === name);
    return t ? t.id : null;
  };

  // Patients board filter dropdowns: the default workflow tags are grouped into
  // a "Breakdowns", an "Estimates" and a "Claims" multi-select filter — one per
  // request type, with the names read from the request-type vocabulary so a
  // renamed or added tag changes here without a second list to keep in step.
  // "Details Needed by Smilepass" intentionally appears in all three. Names resolve to the
  // office's seeded default tag rows (with ids) fetched into `defaultTags`.
  const filterTagNamesFor = (type) =>
    REQUEST_TYPES[type].requestedTagNames.concat([REQUEST_TYPES[type].doneTagName, MISSING_INFO_TAG_NAME]);
  const tagsByName = (names) =>
    names.map((name) => (defaultTags || []).find((t) => t.name === name)).filter(Boolean);
  const breakdownFilterTags = tagsByName(filterTagNamesFor("breakdown"));
  const estimateFilterTags = tagsByName(filterTagNamesFor("estimate"));
  const claimFilterTags = tagsByName(filterTagNamesFor("claim_followup"));
  // Tag filters only apply on the All Patients / Upcoming Patients tabs; the
  // tag-driven tabs (New Breakdowns / New Estimates / Details Needed by Smilepass) are
  // themselves a single-tag filter, so hide the dropdowns there.
  const showTagFilters = selectedSegment === "all-patients" || selectedSegment === "upcoming-patients";
  // Plain-text titles for the list header (the Segmented labels are JSX and
  // can't be interpolated into a string — that rendered "[object Object]").
  const SEGMENT_TITLES = {
    "all-patients": "All Patients",
    "upcoming-patients": "Upcoming Patients",
    "fresh-breakdowns": "New Breakdowns",
    "new-estimates": "New Estimates",
    "need-attention": "Details Needed by Smilepass",
    "ar-cases": "Pending ARs",
    "ar-handled": "Handled ARs",
  };

  const getFreshPatients = async (page, tagName, silent = false) => {
    const tagId = freshTagId(tagName);
    if (!tagId) {
      setMembers({ count: 0, results: [] });
      return;
    }
    // Sort each work tab newest-first by its own date: breakdowns by latest
    // breakdown, estimates by latest estimate, attention by latest of either.
    const SEGMENT_ORDERING = {
      [FRESH_BREAKDOWN_TAG]: "latest_breakdown",
      [NEW_ESTIMATE_TAG]: "latest_estimate",
      [NEEDS_ATTENTION_TAG]: "latest_activity",
    };
    const ordering = SEGMENT_ORDERING[tagName];
    try {
      if (!silent) setIsloadingMembers(true);
      const response = await controller.getMemberList2(page || current, { ...treatmentFilters, ordering }, [tagId]);
      const data = await response.json;
      setMembers(data);
      setPageSize(data.count);
    } catch (error) {
      console.log("Error fetching fresh patients:", error);
      message.error("Something went wrong while getting patients");
    } finally {
      if (!silent) setIsloadingMembers(false);
    }
  };

  const loadFreshCounts = async () => {
    const fetchCount = async (name) => {
      const tagId = freshTagId(name);
      if (!tagId) return 0;
      try {
        const res = await controller.getMemberList2(1, {}, [tagId]);
        const data = await res.json;
        if (data && typeof data.count === "number") return data.count;
        return Array.isArray(data) ? data.length : 0;
      } catch (e) {
        return 0;
      }
    };
    const b = await fetchCount(FRESH_BREAKDOWN_TAG);
    const e = await fetchCount(NEW_ESTIMATE_TAG);
    const na = await fetchCount(NEEDS_ATTENTION_TAG);
    setFreshCounts({ breakdowns: b, estimates: e, needsAttention: na });
  };

  const getAllTags = async () => {
    try {
      setIsGettingTags(true);

      const response = await controller.getAllTags();

      const defaultTags = response.json.filter((tag) => tag.is_default_tag);
      const noneDefaultTags = response.json.filter((tag) => !tag.is_default_tag);

      setDefaultTags(defaultTags);
      setNoneDefaultTags(noneDefaultTags);
      setAllTags(response.json);
    } catch (err) {
      message.error("Something went wrong while getting Tags");
      console.error(err);
    } finally {
      setIsGettingTags(false);
    }
  };

  // Get requiring action patients
  const getRequiringActionsData = async (page, silent = false) => {
    try {
      if (!silent) setIsGettingRequiringActionData(true);

      const treatmentOnlyORArOnly = selectedSegment === "requiring-action" ? "treatment_only" : "ar_only";
      const response = await controller.getRequiringActions(
        treatmentOnlyORArOnly,
        page || current,
        selectedTags,
        sortPatientsBy,
        treatmentFilters,
        arHandledFilter,
      );

      if (response.status === 200) {
        setPageSize(response.json.count);

        // if (treatmentOnlyORArOnly === "all") {
        //   setRequiringActionsData([
        //     ...response.json.results.treatment_ar.map((patient) => ({ ...patient, type: "urgent" })),
        //     ...response.json.results.treatment_only.map((patient) => ({ ...patient, type: "treatment-only" })),
        //     ...response.json.results.ar_only.map((patient) => ({ ...patient, type: "ar-only" })),
        //   ]);
        // } else

        if (treatmentOnlyORArOnly === "treatment_only") {
          setRequiringActionsData([...response.json.results.treatment_only.map((patient) => ({ ...patient, type: "treatment-only" }))]);
        } else if (treatmentOnlyORArOnly === "ar_only") {
          setRequiringActionsData([...response.json.results.ar_only.map((patient) => ({ ...patient, type: "ar-only" }))]);
        }
      }
    } catch (err) {
      message.error("Something went wrong while getting requiring action data");
      console.error(err);
    } finally {
      if (!silent) setIsGettingRequiringActionData(false);
    }
  };

  // Cared for
  const getCaredForPatients = async (page, silent = false) => {
    try {
      if (!silent) setIsGettingCaredForPatients(true);

      const response = await controller.getCaredForPatients(page || current, selectedTags, sortPatientsBy, treatmentFilters);

      if (response.status === 200) {
        setPageSize(response.json.count);
        setCaredForPatients(response.json.results);
      }
    } catch (err) {
      message.error("Something went wrong while getting requiring action data");
      console.error(err);
    } finally {
      if (!silent) setIsGettingCaredForPatients(false);
    }
  };

  // Past Appointment
  const getPastAppointmentPatients = async (page, silent = false) => {
    try {
      if (!silent) setIsGettingPastAppointment(true);

      const response = await controller.getPastAppointmentPatients(page || current, selectedTags, sortPatientsBy, treatmentFilters);

      if (response.status === 200) {
        setPageSize(response.json.count);
        setPastAppointmentPatients(response.json.results);
      }
    } catch (err) {
      message.error("Something went wrong while getting requiring action data");
      console.error(err);
    } finally {
      if (!silent) setIsGettingPastAppointment(false);
    }
  };

  // Past Appointment
  const getHandledAR = async (page, silent = false) => {
    try {
      if (!silent) setIsGettingHandledAR(true);

      const response = await controller.getARHandled(page || current, selectedTags, arHandledFilter, treatmentFilters);

      if (response.status === 200) {
        setPageSize(response.json.count);
        setARHandledPatients(response.json.results);
      }
    } catch (err) {
      message.error("Something went wrong while getting handled ar data");
      console.error(err);
    } finally {
      if (!silent) setIsGettingHandledAR(false);
    }
  };

  const getTodayPatients = async (page, range = null, silent = false) => {
    try {
      if (!silent) setIsGettingTodayPatients(true);

      const response = await controller.getTodayPatients(page || current, selectedTags, selectedTags, treatmentFilters, range);

      if (response.status === 200) {
        setPageSize(response.json.count);
        setTodayPatients(response.json.results);
      }
    } catch (err) {
      message.error("Something went wrong while getting today patients");
      console.error(err);
    } finally {
      if (!silent) setIsGettingTodayPatients(false);
    }
  };

  // `silent` propagates down to whichever segment fetcher runs. Used by
  // the tag-commit refetch so the list block doesn't get torn down
  // mid-task (which used to unmount every TreatmentCard and lose the
  // chip the user just selected). User-driven actions (segment switch,
  // pagination, initial load) still call this without `silent` and get
  // the spinner.
  function getPatientsBySegment(page = undefined, silent = false) {
    console.log(selectedSegment);
    if (selectedSegment === "all-patients") {
      getAllPatients(page, silent);
    } else if (selectedSegment === "past-appointment") {
      getPastAppointmentPatients(page, silent);
    } else if (selectedSegment === "cared-for") {
      getCaredForPatients(page, silent);
    } else if (selectedSegment === "requiring-action" || selectedSegment === "ar-cases") {
      getRequiringActionsData(page, silent);
    } else if (selectedSegment === "ar-handled") {
      getHandledAR(page, silent);
    } else if (selectedSegment === "today-patients") {
      getTodayPatients(page, null, silent);
    } else if (selectedSegment === "upcoming-patients") {
      const option = upcomingRangeOptions.find((o) => o.value === upcomingRange) || upcomingRangeOptions[0];
      getTodayPatients(page, { startDays: option.startDays, endDays: option.endDays }, silent);
    } else if (selectedSegment === "fresh-breakdowns") {
      getFreshPatients(page, FRESH_BREAKDOWN_TAG, silent);
    } else if (selectedSegment === "new-estimates") {
      getFreshPatients(page, NEW_ESTIMATE_TAG, silent);
    } else if (selectedSegment === "need-attention") {
      getFreshPatients(page, NEEDS_ATTENTION_TAG, silent);
    }
  }

  // Silent variant passed to TreatmentCard so a tag commit can refresh
  // the list authoritatively without flipping the global loading flag
  // (which would unmount the row mid-commit). Kept as a memoized identity
  // would be nicer for prop stability, but unnecessary here — the function
  // is recreated each render alongside the rest.
  const refreshPatientsAfterTagCommit = () => getPatientsBySegment(undefined, true);

  // Refresh the board when the guided onboarding tour toggles the demo row.
  useEffect(() => {
    const onDemo = () => getAllPatients(1, true);
    window.addEventListener("guided-onboarding-demo", onDemo);
    return () => window.removeEventListener("guided-onboarding-demo", onDemo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DashboardLayout>
      <div className="my-main-containers">
        <div className="flex-row-space-between-marginBottom-20">
          {/* {currentStep === 1 && <Typography.Title level={4}>Treatment Plans</Typography.Title>} */}
          {currentStep === 1 && <Typography.Title level={4}>Treatment Planning</Typography.Title>}

          {currentStep === 1 ? (
            <Button className="button-primary-small-width" style={{ width: 154, height: 34 }} type="primary" onClick={() => setIsModalVisible(true)}>
              Add
            </Button>
          ) : (
            <></>
          )}
        </div>

        {currentStep === 1 && (
          <Col xs={24} lg={23.2} md={23.2}>
            <Card style={{ width: "100%", position: "relative" }}>
              {/* <Row gutter={[15, 15]} style={{ marginBottom: 20 }} align="center"> */}
              <div className="segments-and-filters">
                {/* Tabs + the Agent Runs launcher, grouped together on the left. */}
                <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0 }}>
                <div style={{ width: "max-content", overflowX: "auto" }}>
                  <Segmented
                    options={treatmentPlansSegmentOptions}
                    defaultValue={selectedSegment}
                    shape="round"
                    className="treatment-plans-segemnts"
                    onChange={(value) => {
                      if (value !== "all-patients") setShowFilters(false);
                      if (value === "requiring-action") setSortPatientsBy("desc");
                      // Reset to page 1 on segment change — otherwise a stale
                      // page from the previous segment (e.g. page 2 of "All
                      // Patients") refetches an out-of-range page on the new
                      // tab, returning empty results even though its count > 0.
                      setCurrent(1);
                      setSelectedTags([]);
                      setSelectedSegment(value);
                    }}
                    style={{ maxWidth: 900, fontSize: 14 }}
                  />
                </div>
                  {/* Persistent, patient-searchable AI agent-run history. */}
                  <AgentRunsLauncher />
                </div>

                {/* Name, email and phone filter */}
                <div style={{ display: "flex", alignItems: "center", gap: 10, justifyContent: "flex-end" }}>
                  <Input
                    onChange={(e) => setSearchQuery(e.target.value)}
                    value={searchQuery}
                    placeholder="Search Patient"
                    prefix={<img src={search} alt="" />}
                    style={{ width: 250, height: 40, marginLeft: "auto", border: "1px solid #6B43B5", borderRadius: 8, padding: "0 11px" }}
                    className="treatment-filter-input"
                  />

                  {selectedSegment === "all-patients" && (
                    <Button
                      style={{ border: "none", height: 40, width: 40, marginLeft: 0 }}
                      // disabled={isGettingProcedures}
                      onClick={() => setShowFilters((show) => !show)}
                    >
                      <img src={filter1} alt="filter" style={{ height: 25, width: 25 }} />
                    </Button>
                  )}
                </div>
              </div>
              {/* </Row> */}

              {selectedSegment === "upcoming-patients" && (
                <div style={{ marginTop: 20, display: "flex", justifyContent: "flex-start" }}>
                  <Segmented
                    options={upcomingRangeOptions.map(({ label, value }) => ({ label, value }))}
                    value={upcomingRange}
                    shape="round"
                    className="treatment-plans-segemnts"
                    onChange={(value) => {
                      setCurrent(1);
                      setUpcomingRange(value);
                    }}
                    style={{ fontSize: 14 }}
                  />
                </div>
              )}

              <Divider />

              {/* Treatment Filters */}
              {showFilters && (
                <div style={{ marginBottom: 30 }}>
                  <TreatmentFilters
                    setTreatmentFilters={setTreatmentFilters}
                    treatmentFilters={treatmentFilters}
                  />

                  <Divider type="horizontal" />

                  {/* <div style={{ display: "flex" }}>
                    <Input
                      onChange={(e) => setSearchQuery(e.target.value)}
                      value={treatmentFilters.name || treatmentFilters.email || treatmentFilters.phone}
                      placeholder="Search Patient"
                      prefix={<img src={search} alt="search" />}
                      style={{ width: 250, height: 40, marginLeft: "auto", border: "1px solid #6B43B5", borderRadius: 8, padding: "0 11px" }}
                      className="treatment-filter-input"
                    />
                  </div> */}
                </div>
              )}

              <Row gutter={[10, 15]} style={{ width: "100%", marginBottom: 30 }} align="center" justify="space-between">
                <Col xs={24} lg={selectedSegment === "ar-handled" ? 6 : 10}>
                  <Typography.Title level={4} style={{ marginBottom: 0 }}>
                    {selectedSegment === "all-patients"
                      ? "All Patients"
                      : `Patient - ${SEGMENT_TITLES[selectedSegment] || ""}`}
                  </Typography.Title>
                </Col>

                {/* {selectedSegment === "requiring-action" ? (
                  <Segmented
                    options={requiringActionTabs}
                    defaultValue={selectedRequiringActionFilter}
                    shape="round"
                    className="treatment-plans-segemnts"
                    onChange={(value) => {
                      setCurrent(1);
                      setSelectedRequiringActionFilter(value);
                    }}
                  />
                ) : (
                  <Button type="primary" onClick={() => setShowManageTagsModal(true)}>
                    Manage Tag
                  </Button>
                  )} */}

                {/* Show sort and manage tag button only in treatment planning page */}
                {!window.location.href.includes("treatment-plans-account-receivable") &&
                  localStorage.getItem("patient-engagment-sub") !== "treatment-plans-account-receivable" && (
                    <Col xs={24} lg={selectedSegment === "ar-handled" ? 18 : 14}>
                      {/* Sort by Days to Appointment */}
                      <Flex align="center" gap={10} justify="flex-end" wrap>
                        {/* Breakdown / Estimate tag filters — only on tabs where
                            free tag filtering applies (All Patients / Upcoming). */}
                        {showTagFilters && (
                          <>
                            <Select
                              mode="multiple"
                              allowClear
                              placeholder="Breakdowns"
                              prefix={<FilterOutlined style={{ color: "#848696" }} />}
                              popupMatchSelectWidth={false}
                              dropdownStyle={{ minWidth: 300 }}
                              className="treatment-filter-input"
                              style={{ minWidth: 170 }}
                              maxTagCount="responsive"
                              value={selectedTags.filter((id) => breakdownFilterTags.some((t) => t.id === id))}
                              options={breakdownFilterTags.map((t) => {
                                const p = paletteForTag(t.name);
                                return { value: t.id, label: p ? <span style={{ color: p.color }}>{t.name}</span> : t.name };
                              })}
                              onChange={(next) => {
                                const groupIds = breakdownFilterTags.map((t) => t.id);
                                setSelectedTags((prev) => [...prev.filter((id) => !groupIds.includes(id)), ...next]);
                              }}
                            />
                            <Select
                              mode="multiple"
                              allowClear
                              placeholder="Estimates"
                              prefix={<FilterOutlined style={{ color: "#848696" }} />}
                              popupMatchSelectWidth={false}
                              dropdownStyle={{ minWidth: 300 }}
                              className="treatment-filter-input"
                              style={{ minWidth: 170 }}
                              maxTagCount="responsive"
                              value={selectedTags.filter((id) => estimateFilterTags.some((t) => t.id === id))}
                              options={estimateFilterTags.map((t) => {
                                const p = paletteForTag(t.name);
                                return { value: t.id, label: p ? <span style={{ color: p.color }}>{t.name}</span> : t.name };
                              })}
                              onChange={(next) => {
                                const groupIds = estimateFilterTags.map((t) => t.id);
                                setSelectedTags((prev) => [...prev.filter((id) => !groupIds.includes(id)), ...next]);
                              }}
                            />
                            <Select
                              mode="multiple"
                              allowClear
                              placeholder="Claims"
                              prefix={<FilterOutlined style={{ color: "#848696" }} />}
                              popupMatchSelectWidth={false}
                              dropdownStyle={{ minWidth: 300 }}
                              className="treatment-filter-input"
                              style={{ minWidth: 170 }}
                              maxTagCount="responsive"
                              value={selectedTags.filter((id) => claimFilterTags.some((t) => t.id === id))}
                              options={claimFilterTags.map((t) => {
                                const p = paletteForTag(t.name);
                                return { value: t.id, label: p ? <span style={{ color: p.color }}>{t.name}</span> : t.name };
                              })}
                              onChange={(next) => {
                                const groupIds = claimFilterTags.map((t) => t.id);
                                setSelectedTags((prev) => [...prev.filter((id) => !groupIds.includes(id)), ...next]);
                              }}
                            />
                          </>
                        )}

                        {/* Sort by Appointment — only meaningful on the Upcoming tab. */}
                        {selectedSegment === "upcoming-patients" && (
                          <>
                            <Typography.Text style={{ marginBottom: 0 }}>Sort by Appointment</Typography.Text>
                            <Select
                              options={[
                                { label: "Ascending", value: "asc" },
                                { label: "Descending", value: "desc" },
                              ]}
                              style={{ width: 130 }}
                              onChange={(value) => setSortPatientsBy(value)}
                              className="treatment-filter-input"
                              value={sortPatientsBy}
                              disabled={
                                isLoadingMembers ||
                                isGettingRequiringActionData ||
                                isGettingCaredForPatients ||
                                isGettingPastAppointment ||
                                isGettingHandledAR
                              }
                            />
                          </>
                        )}

                        <Button type="primary" onClick={() => setShowManageTagsModal(true)}>
                          Manage Tags
                        </Button>
                      </Flex>
                    </Col>
                  )}

                {(selectedSegment === "ar-handled" || selectedSegment === "ar-cases") && (
                  <Select
                    options={arFilterSegments}
                    style={{ width: 190 }}
                    onChange={(value) => setARHandledFilter(value)}
                    className="treatment-filter-input"
                    placeholder="Select AR Duration"
                    mode="multiple"
                    maxTagCount="responsive"
                    disabled={isGettingRequiringActionData}
                  />
                )}
              </Row>

              {/* Custom tags — now shown on ALL treatment-planning tabs (not just
                  All/Upcoming). Each tag gets an auto-assigned, stable distinct
                  color via paletteForTag(). Click toggles it as a filter. */}
              {!window.location.href.includes("treatment-plans-account-receivable") &&
                localStorage.getItem("patient-engagment-sub") !== "treatment-plans-account-receivable" &&
                noneDefaultTags.length > 0 && (
                  <Flex wrap gap={8} align="center" style={{ width: "100%", marginBottom: 30 }}>
                    {noneDefaultTags.map((tag) => {
                      const isSelected = selectedTags.includes(tag.id);
                      const palette = paletteForTag(tag.name);
                      return (
                        <div
                          key={tag.id}
                          style={{
                            padding: "2px 12px",
                            backgroundColor: palette ? palette.backgroundColor : "#f1f1fb",
                            borderRadius: 100,
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                            cursor: "pointer",
                            border: `2px solid ${
                              isSelected
                                ? palette
                                  ? palette.color
                                  : "#6b43b5"
                                : palette
                                  ? palette.borderColor
                                  : "transparent"
                            }`,
                            transition: "all 0.2s",
                          }}
                          onClick={() =>
                            setSelectedTags((prevSelectedTags) =>
                              prevSelectedTags.includes(tag.id)
                                ? prevSelectedTags.filter((tagItem) => tagItem !== tag.id)
                                : [...prevSelectedTags, tag.id],
                            )
                          }
                        >
                          <span
                            style={{
                              color: palette ? palette.color : "#8969c4",
                              fontSize: 12,
                              fontWeight: isSelected ? 600 : 500,
                            }}
                          >
                            {tag.name}
                          </span>
                        </div>
                      );
                    })}
                  </Flex>
                )}

              {isLoadingMembers ||
              isGettingRequiringActionData ||
              isGettingCaredForPatients ||
              isGettingPastAppointment ||
              isGettingHandledAR ||
              isGettingTodayPatients ||
              isGettingTags ? (
                <Row justify={"center"}>
                  <Spin />
                </Row>
              ) : (
                <div>
                  {/* All Patients + the tag-driven Fresh Breakdowns / New
                      Estimates tabs (they fetch into the same `members` state
                      via getFreshPatients, so they reuse this card list). */}
                  {(selectedSegment === "all-patients" ||
                    selectedSegment === "fresh-breakdowns" ||
                    selectedSegment === "new-estimates" ||
                    selectedSegment === "need-attention") &&
                    (Array.isArray(members.results) && members.results.length > 0 ? (
                      members &&
                      members.results &&
                      members.results.map((item, idx) => (
                        <div className="mb" key={item.id}>
                          <TreatmentCard
                            key={item.id}
                            isTourDemo={localStorage.getItem("tourDemoActive") === "1" && selectedSegment === "all-patients" && idx === 0}
                            allTags={allTags}
                            data={item}
                            currentStep={currentStep}
                            setCurrentStep={setCurrentStep}
                            setSelectedPatient={setSelectedPatient}
                            selectedPatient={selectedPatient}
                            selectedSegment={selectedSegment}
                            onPatientInsuranceUpdated={getPatientsBySegment}
                            onTagsCommitted={refreshPatientsAfterTagCommit}
                          />
                        </div>
                      ))
                    ) : (
                      <p>No Patients Found</p>
                    ))}

                  {/* Upcoming Patients (shares today-patients fetcher + state with a day-range) */}
                  {selectedSegment === "upcoming-patients" &&
                    (todayPatients.length > 0 ? (
                      todayPatients.map((item) => (
                        <div className="mb" key={item.id}>
                          <TreatmentCard
                            key={item.id}
                            allTags={allTags}
                            data={item}
                            currentStep={currentStep}
                            setCurrentStep={setCurrentStep}
                            setSelectedPatient={setSelectedPatient}
                            selectedPatient={selectedPatient}
                            selectedSegment={selectedSegment}
                            onPatientInsuranceUpdated={getPatientsBySegment}
                            onTagsCommitted={refreshPatientsAfterTagCommit}
                          />
                        </div>
                      ))
                    ) : (
                      <p>No Patients Found</p>
                    ))}

                  {/* Today Patients */}
                  {selectedSegment === "today-patients" &&
                    (todayPatients.length > 0 ? (
                      todayPatients.map((item) => (
                        <div className="mb" key={item.id}>
                          <TreatmentCard
                            key={item.id}
                            allTags={allTags}
                            data={item}
                            currentStep={currentStep}
                            setCurrentStep={setCurrentStep}
                            setSelectedPatient={setSelectedPatient}
                            selectedPatient={selectedPatient}
                            selectedSegment={selectedSegment}
                            onPatientInsuranceUpdated={getPatientsBySegment}
                            onTagsCommitted={refreshPatientsAfterTagCommit}
                          />
                        </div>
                      ))
                    ) : (
                      <p>No Patients Found</p>
                    ))}

                  {/* Requiring Action Patients */}
                  {(selectedSegment === "requiring-action" || selectedSegment === "ar-cases") &&
                    (requiringActionsData.length > 0 ? (
                      requiringActionsData.map((patient) => (
                        <div className="mb" key={patient.id}>
                          <TreatmentCard
                            key={patient.id}
                            allTags={allTags}
                            data={patient}
                            currentStep={currentStep}
                            setCurrentStep={setCurrentStep}
                            setSelectedPatient={setSelectedPatient}
                            selectedPatient={selectedPatient}
                            selectedSegment={selectedSegment}
                            type={patient.type}
                            onPatientInsuranceUpdated={getPatientsBySegment}
                            onTagsCommitted={refreshPatientsAfterTagCommit}
                          />
                        </div>
                      ))
                    ) : (
                      <p>No Patients Found</p>
                    ))}

                  {/* Cared For Patients */}
                  {selectedSegment === "cared-for" &&
                    (caredForPatients.length > 0 ? (
                      caredForPatients.map((patient) => (
                        <div className="mb" key={patient.id}>
                          <TreatmentCard
                            key={patient.id}
                            allTags={allTags}
                            data={patient}
                            currentStep={currentStep}
                            setCurrentStep={setCurrentStep}
                            setSelectedPatient={setSelectedPatient}
                            selectedPatient={selectedPatient}
                            selectedSegment={selectedSegment}
                            onPatientInsuranceUpdated={getPatientsBySegment}
                            onTagsCommitted={refreshPatientsAfterTagCommit}
                          />
                        </div>
                      ))
                    ) : (
                      <p>No Patients Found</p>
                    ))}

                  {/* Past Appointment Patients */}
                  {selectedSegment === "past-appointment" &&
                    (pastAppointmentPatients.length > 0 ? (
                      pastAppointmentPatients.map((patient) => (
                        <div className="mb" key={patient.id}>
                          <TreatmentCard
                            key={patient.id}
                            allTags={allTags}
                            data={patient}
                            currentStep={currentStep}
                            setCurrentStep={setCurrentStep}
                            setSelectedPatient={setSelectedPatient}
                            selectedPatient={selectedPatient}
                            selectedSegment={selectedSegment}
                            onPatientInsuranceUpdated={getPatientsBySegment}
                            onTagsCommitted={refreshPatientsAfterTagCommit}
                          />
                        </div>
                      ))
                    ) : (
                      <p>No Patients Found</p>
                    ))}

                  {/* AR Handled */}
                  {selectedSegment === "ar-handled" &&
                    (arHandledPatients.length > 0 ? (
                      arHandledPatients.map((patient) => (
                        <div className="mb" key={patient.id}>
                          <TreatmentCard
                            key={patient.id}
                            allTags={allTags}
                            data={patient}
                            currentStep={currentStep}
                            setCurrentStep={setCurrentStep}
                            setSelectedPatient={setSelectedPatient}
                            selectedPatient={selectedPatient}
                            selectedSegment={selectedSegment}
                            onPatientInsuranceUpdated={getPatientsBySegment}
                            onTagsCommitted={refreshPatientsAfterTagCommit}
                          />
                        </div>
                      ))
                    ) : (
                      <p>No Patients Found</p>
                    ))}
                </div>
              )}
            </Card>
            <Row type="flex" justify="center" style={{ marginBottom: 35, marginTop: 35 }}>
              <Pagination
                showSizeChanger={false}
                hideOnSinglePage={true}
                current={current}
                total={pageSize}
                onChange={(page) => {
                  setCurrent(page);
                  getPatientsBySegment(page);
                }}
                className="paginator"
              />
            </Row>
          </Col>
        )}

        {currentStep === 2 && (
          <Col xs={24} lg={23.2} md={23.2} style={{ marginRight: 25, marginLeft: 15 }}>
            <TreatmentPlanDetailsOrPaymentRequest
              setSelectedPatient={setSelectedPatient}
              selectedSegment={selectedSegment}
              setCurrentStep={setCurrentStep}
              newPatientID={newPatientID}
              currentStep={currentStep}
              selectedPatient={selectedPatient}
            />
          </Col>
        )}

        <ManageTagsModal
          setShowManageTagsModal={setShowManageTagsModal}
          showManageTagsModal={showManageTagsModal}
          allTags={allTags}
          getAllTags={getAllTags}
        />

        <ModalComponent
          setSelectedPatient={setSelectedPatient}
          setIsModalVisible={setIsModalVisible}
          setNewPatientID={setNewPatientID}
          isModalVisible={isModalVisible}
          setCurrentStep={setCurrentStep}
          filter={filter}
          data1={data}
          list={list}
        />
      </div>

      <PaymentReportModal
        isGettingHelcimApprovedCard={isGettingHelcimApprovedCard}
        setShowPaymentReportModal={setShowPaymentReportModal}
        showPaymentReportModal={showPaymentReportModal}
        setCurrentPaymentStep={setCurrentPaymentStep}
        currentPaymentStep={currentPaymentStep}
        setPaymentType={setPaymentType}
        payResult1={payResult1}
        payResult={payResult}
        response2={response2}
        response={response}
      />
    </DashboardLayout>
  );
}

function TreatmentLabel({ icon, data, label, changeMargin, numOfLabels }) {
  const screens = useBreakpoint();
  const isLargeView = screens.xl && !screens.xxl;

  return (
    <Col xs={24} sm={24} md={12} xl={24 / numOfLabels}>
      <div
        style={{
          height: 121,
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          background: "rgba(223, 218, 255, 0.7)",
          borderRadius: "8px",
        }}
      >
        <div className="circle" style={{ marginLeft: 20, minWidth: 82 }}>
          <img className="icon-center" src={icon} alt="" />
        </div>
        <div style={{ marginLeft: changeMargin && isLargeView ? 6 : 25 }}>
          <div style={{ fontSize: 16, fontWeight: 400, color: "#4D3280", marginBottom: 10 }}>{label}</div>
          <div style={{ fontSize: 24, color: "#4D3280", fontWeight: 500 }}>{data}</div>
        </div>
      </div>
    </Col>
  );
}
